if (!customElements.get('ma-reviewed-card-media')) {
  customElements.define('ma-reviewed-card-media', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.panel = this.querySelector('[data-media-panel]');
      this.colour = this.querySelector('[data-media-colour]');
      this.views = [...this.querySelectorAll('[data-media-view]')];
      this.status = this.querySelector('[data-media-status]');
      this.colour.disabled = false;
      this.querySelector('[data-media-controls]').hidden = false;
      this.querySelector('[data-media-initial]')?.remove();
      this.colour.addEventListener('change', () => this.show('model'));
      this.views.forEach(button => button.addEventListener('click', () => this.show(button.dataset.mediaView)));
      this.show('model');
    }

    show(requestedView) {
      const template = [...this.querySelectorAll('template[data-media-colour-template]')]
        .find(item => item.dataset.mediaColourTemplate === this.colour.value);
      if (!template) return;
      const available = ['model', 'flat'].filter(view => template.content.querySelector(`[data-media-image-view="${view}"]`));
      const view = available.includes(requestedView) ? requestedView : (available[0] || 'unavailable');
      const content = template.content.querySelector(`[data-media-image-view="${view}"]`).cloneNode(true);
      this.panel.replaceChildren(content);
      this.views.forEach(button => {
        button.disabled = !available.includes(button.dataset.mediaView);
        button.setAttribute('aria-pressed', String(button.dataset.mediaView === view));
      });
      const missing = this.views.filter(button => !available.includes(button.dataset.mediaView));
      this.status.textContent = missing.map(button => `${button.textContent.trim()}: ${this.dataset.unavailable}`).join(' ');
      const card = this.closest('product-card');
      if (card) {
        const url = new URL(template.dataset.productUrl, location.origin);
        card.querySelectorAll('a').forEach(link => {
          const next = new URL(link.href, location.origin);
          if (next.origin !== url.origin || next.pathname.split('/products/')[1] !== url.pathname.split('/products/')[1]) return;
          const variant = url.searchParams.get('variant');
          if (variant) next.searchParams.set('variant', variant);
          else next.searchParams.delete('variant');
          link.href = next.href;
        });
        const image = content.querySelector('img');
        if (image) card.setAttribute('data-featured-media-url', image.src);
        else card.removeAttribute('data-featured-media-url');
      }
    }
  });
}
